import { useDispatch, useSelector } from "react-redux";

const initialState = {
    "createdAt": null,
    "updatedAt": null,
    "siniestro_id": null,
    "nombre": null,
    "fecha_ini": null,
    "fecha_fin": null,
    "fecha_emi": null,
    "empresa_id":null,
    "cliente_id": null,
    "ramo_id": null,
    "estatus_contrato_id": null,
    "movimientos": [],
    "dashboard": false,
};

export const useSiniester = () => {
    const dispatch=useDispatch();
    const siniesterState = useSelector(state => state.siniester);
    const setSiniester = (siniesterData) => {
        dispatch({
            type: '@siniester/setSiniester',
            payload: {
                ...siniesterData
            }
        });
    };
    const resetSiniester = () => {
        dispatch({
            type: '@siniester/setSiniester',
            payload: {
                ...initialState
            }
        });
    };
    return { siniesterState, setSiniester, resetSiniester };
};


export const siniesterReducer = (state = initialState, action) => {
    switch(action.type){
        case '@siniester/setSiniester':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};